import { useEffect, useMemo, useState } from 'react';

import { getBackofficeBrands } from 'backoffice/_api';

const useBackofficeBrandFilter = (intl, enabled = true) => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setBrands([]);
      return () => {};
    }

    let mounted = true;

    getBackofficeBrands()
      .then(({ data }) => {
        if (mounted) {
          setBrands(Array.isArray(data) ? data : data?.results || []);
        }
      })
      .catch(() => {
        if (mounted) {
          setBrands([]);
        }
      });

    return () => {
      mounted = false;
    };
  }, [enabled]);

  return useMemo(
    () => ({
      title: 'justBrand',
      accessor: 'brand',
      options: [
        { value: '', label: intl.formatMessage({ id: 'justAll' }) },
        ...brands.map(brand => ({
          value: String(brand.id),
          label: brand.title,
        })),
      ],
      searchable: true,
    }),
    [brands, intl]
  );
};

export default useBackofficeBrandFilter;
